import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
		path: '/',
		redirect: '/login'
	}, {
		path: "/login",
		name: "Login",
		meta: {
			title: "登录",
		},
		component: () => import("@/views/login/login"),
	},
	{
		path: "/business",
		name: "Business",
		meta: {
			title: "业务中心",
		},
		component: () => import("@/views/nav/business"),
	},
	{
		path: "/reporting-management",
		name: "ReportingManagement",
		meta: {
			title: "业务管理中心",
		},
		component: () => import("@/views/reporting-management"),
	},
	{
		path: "/data-management",
		name: "DataManagement",
		meta: {
			title: "数据管理",
		},
		component: () => import("@/views/data-management"),
	},
	{
		path: "/empowerment",
		name: "Empowerment",
		meta: {
			title: "AI赋能中心",
		},
		component: () => import("@/views/nav/empowerment"),
	},
	{
		path: '/not-permission',
		name: 'NotPermission',
		component: () => import('@/views/error-page/empty'),
	},
	{
		path: '/data-manage',
		name: 'DataManage',
		component: () => import('@/views/nav/data-manage'),
	},
	{
		path: '/404',
		component: () => import('@/views/error-page/404')
	},
	// {
	// 	path: '/401',
	// 	component: () => import('@/views/error-page/401'),
	// 	hidden: true
	// },
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
	// 404 page must be placed at the end !!!

]

const createRouter = () => new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router